module.exports = __webpack_public_path__ + "img/concept-no-bg.4666d010.png";